import gql from 'graphql-tag';
import { DEAL_CALL_ACTIVITY_FRAGMENT } from './fragments/dealCallActivity.fragment';
import { DEAL_NOTE_ACTIVITY_FRAGMENT } from './fragments/dealNoteActivity.fragment';

export const DELETE_DEAL_ACTIVITIES = gql`
  mutation UpdateDealActivities($input: DeleteDealActivityInput!) {
    dealActivity {
      result: deleteDealActivity(input: $input) {
        error
        success
        entity {
          __typename
          ...DealCallActivityFields
          ...DealNoteActivityFields
        }
      }
    }
  }
  ${DEAL_CALL_ACTIVITY_FRAGMENT}
  ${DEAL_NOTE_ACTIVITY_FRAGMENT}
`;
